import React from 'react';

const Mainrow = props => (
  <div className='pageHead-mainRow-container'>
    <div className='pageHead-mainRow wrapper'>
    <div className="pageHead-title">
      {/* <a className="mb-1" href="/fichaventa/fichaventa.html">
        <i className="ion-chevron-left mr-2"></i>
        <span>Volver a listado de FDV</span>
      </a> */}
      Ficha de venta
    </div>


      <div className='pageHead-mainRow-actions'>
        <button className='btn btn-primary' onClick={() => props.openModal('nueva-fdv')}>Nueva Ficha de Venta</button>
        <div className='dropdown kebab customToggle' role='group'>
          <button className='btn dropdown-toggle kebab-btn' name='btnDropdownToggle'><i className='ion-android-more-vertical' name='iconDropdownToggle' /></button>
          <ul className='dropdown-menu dropdown-menu-right'>
            {/* <li >
              <a className='pageHead-tableActionItem'>
              <i className='ion-android-mail c-cyan' />
              <span>Compartir por Email</span>
            </a>
          </li>
          <li >
          <a className='pageHead-tableActionItem'>
          <i className='ion-arrow-down-a c-cyan' />
          <span>Descargar PDF</span>
        </a>
      </li> */}
            <li >
              <a className='pageHead-tableActionItem' onClick={props.clickDescargarExcel} >
                <i className='ion-arrow-down-a c-cyan' />
                <span>Descargar Excel</span>
              </a>
            </li>
            {/*Inicio Req. 92349 ebarboza 18 06 2021 */}
            <li >
              <a className='pageHead-tableActionItem' onClick={props.clickDescargarExcelBonos} >
                <i className='ion-arrow-down-a c-cyan' />
                <span>Descargar Excel Bonos</span>
              </a>
            </li>
            {/*Fin Req. 92349 ebarboza 18 06 2021 */}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default Mainrow;



// WEBPACK FOOTER //
// ./src/components/IndexFichaVenta/mainrow.js